import React from "react";
import {
  Button,
  Modal,
  Loader,
  Avatar,
  Iconography,
  IconographySizes,
  IconographyThemes,
  LoaderSizes,
} from "@hid-galaxy-ui/galaxy-react";
import "./DeleteModal.scss";
import { AvatarSizes } from "@hid-galaxy-ui/galaxy-react/components/Avatar/AvatarEnums";

interface DeleteModalProps {
  setDeleteOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onDeleteButtonClick: () => void;
  deleteButtonLoading: boolean;
  optionalHeader?: string;
  width?: number;
  info?: {
    icon: string;
    name: string;
  };
  message: string;
  deleteResultStatus?: "idle" | "success" | "error";
  deleteResultMessage?: string;
  successMessage?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  setDeleteOpen,
  onDeleteButtonClick,
  deleteButtonLoading,
  optionalHeader = "Delete Confirmation",
  width = 420,
  info,
  message,
  deleteResultStatus = "idle",
  deleteResultMessage = "",
  successMessage = "Deleted successfully",
}) => {
  const showStatusView =
    deleteButtonLoading ||
    deleteResultStatus === "success" ||
    deleteResultStatus === "error";

  const handleClose = () => setDeleteOpen(false);

  const renderStatusView = () => (
    <div className="delete-status-container">
      {deleteButtonLoading ? (
        <div className="delete-status-container__loading">
          <Loader variant={LoaderSizes.large} />
        </div>
      ) : deleteResultStatus === "success" ? (
        <>
          <Iconography
            icon="circleCheck"
            size={IconographySizes.XLarge}
            theme={IconographyThemes.Success}
            className="delete-status-container__icon"
          />
          <div className="delete-status-container__message">{successMessage}</div>
          {info && (
            <div className="delete-status-container__info">
              <div className="delete-status-container__name">{info.name}</div>
            </div>
          )}
          <Button variant="primary" label="Close" onClick={handleClose} />
        </>
      ) : (
        <>
          <Iconography
            icon="circleXmark"
            size={IconographySizes.XLarge}
            theme={IconographyThemes.Error}
            className="delete-status-container__icon"
          />
          <div className="delete-status-container__message">
            {deleteResultMessage || "Something went wrong!"}
          </div>
          <Button variant="primary" label="Close" onClick={handleClose} />
        </>
      )}
    </div>
  );

  return (
    <Modal
      optionalHeader={showStatusView ? undefined : optionalHeader}
      headerText={showStatusView ? "" : undefined}
      width={width}
      onClose={handleClose}
      className="delete-confirm-modal"
    >
      {showStatusView ? (
        renderStatusView()
      ) : (
        <div className="message-button-container">
          {info && (
            <div className="info-container">
              <Avatar
                size={AvatarSizes.Large}
                editorProps={{
                  icon: info.icon,
                }}
              />{" "}
              <span>{info.name}</span>
            </div>
          )}
          <div className="message-text">{message}</div>
          <div className="button-group">
            <Button variant="secondary" label="Cancel" onClick={handleClose} />
            <div className="delete-button-wrapper">
              <Button
                variant="primary"
                label="Delete"
                disabled={deleteButtonLoading}
                onClick={onDeleteButtonClick}
              />
              {deleteButtonLoading && <Loader />}
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default DeleteModal;
